import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { ProspectusTasksTable } from '../../../../../../../../../../features/prospectus/task/prospectus-tasks-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/prospectus-task/_task/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorBetaNxt,
      label: 'Prospectus Tasks',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorBetaNxt>,
  head: () => getPageHead('Prospectus Jobs'),
  component: BetaNxtProspectusTaskList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingVendorBetaNxt}
      />
    </VerticalStack>
  );
}

function BetaNxtProspectusTaskList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <ProspectusTasksTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
